const ProductNotFound = () => {
	return (
		<section className=" h-[calc(100vh-22.3rem)] md:h-[calc(100vh-35.3rem)] lg:md:h-[calc(100vh-27.8rem)] flex flex-col items-center justify-center ">
			<h1 className="font-DynaPuff text-[0.7rem]">
				EL PRODUCTO DE LA BÚSQUEDA NO EXISTE...
				<br />
				INTENTE NUEVAMENTE!
			</h1>
		</section>
	);
};

export { ProductNotFound };
